import usePageTitle from '@/hooks/use-page-title';
import { Link, Route, Routes } from "react-router-dom";
import { ChevronRight } from 'lucide-react';
import SmallSpinner from '@/components/shared/spinners/small-spinner';
import { useContracts } from '@/hooks/api/use-contracts';
import ListeQuestions from "@/pages/questions/liste-questions";

const Questions = () => {
    usePageTitle('Mes questions');
    const contractsQuery = useContracts();

    if (contractsQuery.isPending) return <SmallSpinner />;

    return (
        <div className="w-full">
            <nav className="flex items-center gap-1.5 text-xs sm:text-sm text-muted-foreground mt-4" aria-label="Fil d'Ariane">
                <Link to="/" className="hover:text-foreground transition-colors no-underline">Mon espace</Link>
                <ChevronRight className="w-3 h-3 sm:w-3.5 sm:h-3.5" />
                <Link to="/mes-questions" className="hover:text-foreground transition-colors no-underline">Mes questions</Link>
            </nav>
            <div className="space-y-2 sm:space-y-3 mt-4">
                <h1 className="text-xl sm:text-2xl font-bold">Mes questions</h1>
            </div>

            <Routes>
                <Route index element={<ListeQuestions />} />
            </Routes>
        </div>
    );
};

export default Questions;
